module.exports = __webpack_public_path__ + "img/thumbnail_gyalalzuur.aed1fde0.png";